import { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Form, Field } from 'redux-form';

import { SelectField, StaticField } from 'common/components/forms';
import { Modal, FormError } from 'common/components/layout';
import { exchangeItemOnShipment } from 'redux/clubSubscriptionShipments/actions';

import { validateExchange } from '../validators';

import { itemsInClub, listItemsInClubExceptProductVariant } from './helpers';

class ExchangeProductVariant extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false
    };
  }

  handleSubmit = (form) => {
    this.setState({ isSubmitting: true });
    const { props } = this;
    const data = transformData(form, props);
    const successFunction = () => {
      this.setState({ isSubmitting: false });
      props.onCloseModal();
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    props.exchangeItemOnShipment(
      props.clubSubscriptionShipment.id,
      props.productVariantId,
      data,
      successFunction,
      errorFunction
    );
  };

  handleClose = (e) => {
    const { props } = this;
    e.preventDefault();
    props.onCloseModal();
  };

  render() {
    const { handleSubmit, form, onCloseModal } = this.props;
    const { club, clubSubscriptionShipment, productVariantId } = this.props;
    const { isSubmitting } = this.state;
    return (
      <Modal
        className="c7-modal__content--add-hold"
        title="Exchange a Product On Your Shipment"
        onCloseModal={onCloseModal}
        formName={form}
      >
        <FormError formName={form} />
        <Form
          onSubmit={handleSubmit(this.handleSubmit)}
          className="c7-form"
          method="post"
        >
          <Field
            label="Remove Product"
            name="initialItem"
            component={StaticField}
          />
          <Field
            name="swapWithProductVariantId"
            component={SelectField}
            label="Exchange With"
            optionArray={exchangeProducts(
              clubSubscriptionShipment,
              club,
              productVariantId
            )}
            required
          />
          <div className="c7-form__button-row">
            <a onClick={this.handleClose} className="c7-button-alt">
              Cancel
            </a>
            <button type="submit" className="c7-button" disabled={isSubmitting}>
              Exchange Product
            </button>
          </div>
        </Form>
      </Modal>
    );
  }
}

const transformData = (values) => {
  const data = {
    swapWithProductVariantId: values.swapWithProductVariantId
  };
  return data;
};

const validate = (values) => {
  const data = transformData(values);
  const errors = validateExchange(data);
  return errors;
};

const mapStateToProps = (state, ownProps) => {
  const initialItem = itemsInClub(
    ownProps.productVariantId,
    ownProps.clubSubscriptionShipment
  );
  return {
    initialValues: {
      initialItem: initialItem?.productTitle
    }
  };
};

const exchangeProducts = (clubSubscriptionShipment, club, productVariantId) => {
  const items = listItemsInClubExceptProductVariant(
    clubSubscriptionShipment,
    club,
    productVariantId
  );

  const optionArray = [{ value: '', option: '' }];
  items.forEach((item) => {
    optionArray.push({
      value: item.productVariantId,
      option: item.productTitle
    });
  });
  return optionArray;
};

ExchangeProductVariant = reduxForm({
  form: 'ExchangeProductVariant',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(ExchangeProductVariant);

export default connect(mapStateToProps, {
  exchangeItemOnShipment
})(ExchangeProductVariant);
